import { useEffect } from 'react'

import { useGetUserQuery } from 'common'
import Storage from 'services/base/storage'

const storage = new Storage('admin_center_notification')
const key = 'has_seen'
const backupKey = 'backup_has_seen'

export const useHasSeenNotification = () => {
  const { data: { is_pretending: isPretending } } = useGetUserQuery()
  const hasSeenNotification = storage.get(key) === 'true'

  // store the user's original value when pretend mode is used
  // restore it back when pretend mode is exited
  useEffect(() => {
    const backupValue = storage.get(backupKey)
    const oldValue = storage.get(key)

    if (isPretending && !backupValue && !!oldValue) {
      storage.set(backupKey, oldValue)
      storage.remove(key)
    }

    if (!isPretending && !!backupValue) {
      storage.set(key, backupValue)
      storage.remove(backupKey)
    }
  }, [isPretending])

  const setHasSeenNotification = (value) => {
    if (value) {
      storage.set(key, 'true')
    } else {
      storage.remove(key)
    }
  }

  return [hasSeenNotification, setHasSeenNotification]
}
